import React from 'react';
import { useFirebase } from '../contexts/FirebaseContext';
import { JarTipContainer } from './JarTipContainer';
import { Coins } from 'lucide-react';

export const JarTipsPage: React.FC = () => {
  const { tenantId, role, user } = useFirebase();
  const isSuperAdmin = user?.email?.toLowerCase() === 'admin@growezy.ai';
  const isAdminOrManager = role === 'admin' || role === 'manager' || role === 'owner' || isSuperAdmin;

  if (!isAdminOrManager || !tenantId) {
    return (
      <div className="p-8 text-center bg-gray-900 text-white min-h-screen">
        <h2 className="text-xl font-bold text-white">Access Restricted</h2>
        <p className="text-gray-400 mt-2">Only managers and administrators have permission to submit shift tip jar collections.</p>
      </div>
    );
  }

  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-gray-200 pb-5">
        <div>
          <h1 className="text-2xl md:text-3xl font-black text-gray-900 tracking-tight">Submit Jar Tips</h1>
          <p className="text-gray-500 text-sm mt-1">
            Log cash from the tip jar to allocate among shift staff.
          </p>
        </div>
      </div>

      {/* Main Form & Submissions */}
      <JarTipContainer 
        tenantId={tenantId} 
        userEmail={user?.email || ''} 
        isAdminOrManager={isAdminOrManager} 
      />
    </div>
  );
};
